import { render, staticRenderFns } from "./ConfigGV_Proceso.vue?vue&type=template&id=1dece329&scoped=true"
import script from "./ConfigGV_Proceso.vue?vue&type=script&lang=js"
export * from "./ConfigGV_Proceso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dece329",
  null
  
)

export default component.exports